import { render, staticRenderFns } from "./FormCampanaAbonos.vue?vue&type=template&id=48a4685c"
import script from "./FormCampanaAbonos.vue?vue&type=script&lang=js"
export * from "./FormCampanaAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports